import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { Map, MapPin, Building2, Network, UserRound, Truck, Search, ChevronLeft, ChevronRight } from 'lucide-react'
import s from './PanelBase.module.scss'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'
import ReadOnlyOperatorsList from './ReadOnlyOperatorsList'
import ReadOnlyDriversList from './ReadOnlyDriversList'
import ReadOnlyBranchesList from './ReadOnlyBranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const TopBasesPanel = ({
  topBasesFilter,
  setTopBasesFilter,
  filteredTopBases,
  topBasesPagination,
  loadTopBasesPage,
  expandedTopBase,
  setExpandedTopBase,
  expandedOperatorsTopBase,
  setExpandedOperatorsTopBase,
  expandedDriversTopBase,
  setExpandedDriversTopBase,
  expandedBranchesTopBase,
  setExpandedBranchesTopBase,
  loadOperatorsByTopBasePage,
  loadDriversByTopBasePage,
  loadBranchesByTopBasePage,
  operatorsByTopBase,
  driversByTopBase,
  branchesByTopBase,
  operatorsPaginationByTopBase,
  driversPaginationByTopBase,
  branchesPaginationByTopBase,
  operatorsFilterByTopBase,
  driversFilterByTopBase,
  branchesFilterByTopBase,
  setOperatorsFilterByTopBase,
  setDriversFilterByTopBase,
  setBranchesFilterByTopBase,
  expandedDriverByTopBase,
  toggleDriver,
  topBases
}) => {
  useInterfaceLanguage();
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <SectionHeading icon={Building2} title={tr("ТОП-Базы")} />
        {tr(topBasesPagination?.count > 0 && (
          <span className={s.totalBadge}>{tr("Всего: ")}{tr(topBasesPagination.count)}</span>
        ))}
      </div>

      <div className={s.searchRow}>
        <Search size={16} aria-hidden="true" />
        <input className={s.searchInput} placeholder={tr("Поиск по базе...")} value={topBasesFilter} onChange={(e) => setTopBasesFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadTopBasesPage(1, topBasesFilter) }} />
      </div>

      {filteredTopBases && filteredTopBases.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Название")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Местоположение")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredTopBases.map((tb, index) => (
                <React.Fragment key={tb.id}>
                  <tr>
                    <td data-label={tr("№")} className={s.numCell}>{tr(index + 1)}</td>
                    <td data-label={tr("Название")} className={s.nameCell} onClick={() => { const newVal = (expandedTopBase === tb.id ? null : tb.id); setExpandedTopBase(newVal); if (newVal) loadOperatorsByTopBasePage(tb.id, 1); }}>{tr(tb.name)}</td>
                    <td data-label={tr("Телефон")}>{tr(tb.phone || '—')}</td>
                    <td data-label={tr("Местоположение")}>
                      {tb.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${tb.geo}`, '_blank')} className={s.geoBtn}><Map size={14} aria-hidden="true" />{tr(" Карты")}</button>
                            <button onClick={() => { const el = document.getElementById(`map-${tb.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none'; }} className={s.mapToggleBtn} aria-label={tr("Показать или скрыть мини-карту")}><MapPin size={15} aria-hidden="true" /></button>
                          </div>
                          <div id={`map-${tb.id}`} style={{ width: 200, height: 150, display: 'none' }}><MiniMap geo={tb.geo} /></div>
                        </div>
                      ) : '—'}
                    </td>
                    <td data-label={tr("Действия")}>
                      <button className={`${s.actionBtn}${expandedBranchesTopBase === tb.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedBranchesTopBase === tb.id ? null : tb.id; setExpandedBranchesTopBase(v); if (v) loadBranchesByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}><Network size={14} aria-hidden="true" />{tr("Филиалы")}</button>
                      <button className={`${s.actionBtn}${expandedOperatorsTopBase === tb.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedOperatorsTopBase === tb.id ? null : tb.id; setExpandedOperatorsTopBase(v); if (v) loadOperatorsByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}><UserRound size={14} aria-hidden="true" />{tr("Операторы")}</button>
                      <button className={`${s.actionBtn}${expandedDriversTopBase === tb.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedDriversTopBase === tb.id ? null : tb.id; setExpandedDriversTopBase(v); if (v) loadDriversByTopBasePage(tb.id, 1); setExpandedTopBase(tb.id); }}><Truck size={14} aria-hidden="true" />{tr("Водители")}</button>
                    </td>
                  </tr>
                  {tr(expandedTopBase === tb.id && (
                    <tr className={s.subRow}>
                      <td colSpan={5}>
                        <div className={s.subContent}>
                          {tr(expandedOperatorsTopBase === tb.id && (
                            <ReadOnlyOperatorsList
                              base={tb}
                              operators={operatorsByTopBase[tb.id]}
                              operatorsFilter={operatorsFilterByTopBase[tb.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadOperatorsPage={loadOperatorsByTopBasePage}
                              operatorsPagination={operatorsPaginationByTopBase[tb.id]}
                              title={tr("Операторы этой ТОП-базы")}
                            />
                          ))}

                          {tr(expandedDriversTopBase === tb.id && (
                            <ReadOnlyDriversList
                              base={tb}
                              drivers={driversByTopBase[tb.id]}
                              driversFilter={driversFilterByTopBase[tb.id]}
                              setDriversFilter={(v) => setDriversFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadDriversPage={loadDriversByTopBasePage}
                              driversPagination={driversPaginationByTopBase[tb.id]}
                              expandedDriver={expandedDriverByTopBase}
                              toggleDriver={toggleDriver}
                              title={tr("Водители этой ТОП-базы")}
                            />
                          ))}

                          {tr(expandedBranchesTopBase === tb.id && (
                            <ReadOnlyBranchesList
                              base={tb}
                              baseType="ТОП-базы"
                              branches={branchesByTopBase[tb.id]}
                              branchesFilter={branchesFilterByTopBase[tb.id]}
                              setBranchesFilter={(v) => setBranchesFilterByTopBase(prev => ({ ...prev, [tb.id]: v }))}
                              loadBranchesPage={loadBranchesByTopBasePage}
                              branchesPagination={branchesPaginationByTopBase[tb.id]}
                            />
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <EmptyState icon={Building2} title={tr("Список пуст")} description={tr("Измените поиск или проверьте записи в этом разделе.")} compact />
      )}

      {tr(!topBasesFilter && topBasesPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!topBasesPagination.previous} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) - 1)}><ChevronLeft size={15} aria-hidden="true" />{tr("Пред.")}</button>
          <span>{tr("Стр. ")}{tr(topBasesPagination.page || 1)}{tr(" из ")}{Math.ceil(topBasesPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!topBasesPagination.next} onClick={() => loadTopBasesPage((topBasesPagination.page || 1) + 1)}>{tr("След.")}<ChevronRight size={15} aria-hidden="true" /></button>
        </div>
      ))}
    </div>
  )
}

export default TopBasesPanel
